module.exports = __webpack_public_path__ + "img/cn_download.d1778690.png";